// Navbar.jsx
import React, { useEffect, useState } from "react";
// import "../style/clientNavbar-style.css";
import { Link, useLocation, useNavigate, Navigate } from "react-router-dom";
// import whatsAppImg from "../../../../assets/images/whatsapp.png";
import { logout, selectClientAuth } from "../../auth-client/slice/clientAuth";
import { useSelector, useDispatch } from "react-redux";
import { googleLogout } from '@react-oauth/google';
import { getClientInfo } from "../../client-panel/slice/clientPanelInfoSlice";
import { incrementNotification } from "../slice/clientNavigationSlice";
import Pusher from "pusher-js";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ClientNavbar = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const isClientLoggedIn = useSelector(selectClientAuth);
  const clientName = useSelector((state) => state.clientInfo.clientsInfo?.first_name);
  const clientProfileImage = useSelector((state) => state.clientInfo.clientsInfo?.profile_image);
  const clientIsVerified = useSelector((state) => state.clientInfo.clientsInfo?.is_verified);
  const unreadCount = useSelector((state) => state.clientNavigation.unreadCount);
  const { clientLastMessages, adminLastMessages } = useSelector(
    (state) => state.clientChatList
  );
  const clientToken = localStorage.getItem("client_access_token");

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  const fundraisingLinks = [
    { name: "Capital Campaign", path: "/capital-campaign" },
    { name: "Our Facility", path: "/our-facility" },
    { name: "Ways to Give", path: "/ways-to-give" },
    { name: "Naming Opportunities", path: "/naming-opportunities" },
    { name: "Corporate Partners", path: "/corporate-partners" },
    { name: "Campaign Updates", path: "/campaign-updates" },
    { name: "Contact Campaign Team", path: "/campaign-contact" },
  ];


  console.log("unreadCount", unreadCount);

  useEffect(() => {
    const clientToken = localStorage.getItem("client_access_token");
    const clientId = localStorage.getItem("user_id");
    const currentUserType = "Icommunetech\\Client\\Models\\Client";

    if (!clientToken || !clientId) return;

    const pusher = new Pusher("71055cc21a087085dc31", {
      cluster: "ap2",
      forceTLS: true,
      authEndpoint: `${BACKEND_URL}/pusher/auth`,
      auth: {
        headers: {
          Authorization: `Bearer ${clientToken}`,
        },
      },
    });

    // ✅ Subscribe to global ChatRoomCreated event
    const globalChannel = pusher.subscribe("private-chat_room");
    globalChannel.bind("App\\Events\\ChatRoomCreated", (data) => {
      if (String(data?.to_id) === String(clientId)) {
        dispatch(incrementNotification());
      }
    });

    // ✅ Subscribe to individual chat channels for real-time message events
    const allChats = [...(clientLastMessages || []), ...(adminLastMessages || [])];
    const chatChannels = [];

    allChats.forEach((chat) => {
      const chatChannel = pusher.subscribe(`private-chat_${chat.chat_id}`);

      chatChannel.bind("App\\Events\\MessageSent", (data) => {
        const { message } = data;

        const isToMe =
          String(message.to_id) === String(clientId) &&
          message.to_type === currentUserType;

        if (isToMe) {
          dispatch(incrementNotification());
        }
      });

      chatChannels.push(chatChannel);
    });

    // Cleanup
    return () => {
      globalChannel.unbind_all();
      globalChannel.unsubscribe();

      chatChannels.forEach((channel) => {
        channel.unbind_all();
        channel.unsubscribe();
      });

      pusher.disconnect();
    };
  }, [clientLastMessages, adminLastMessages, dispatch]);


  const isTokenValid = () => {
    const expiryTime = localStorage.getItem("client_token_expiry");
    if (!expiryTime) return false;

    const currentTime = new Date().getTime();
    return currentTime < parseInt(expiryTime);
  };

  useEffect(() => {
    const tokenValid = isTokenValid();

    if (!tokenValid) {
      dispatch(logout());
      googleLogout();
      // navigate("/signin");
    } else if (clientToken) {
      // Only fetch client info if token exists and is valid
      dispatch(getClientInfo(clientToken));
    }
  }, [dispatch, navigate, clientToken]);

  const clientImageUrl = clientProfileImage
    ? `${process.env.REACT_APP_PROFILE_IMAGE_BACKEND_URL}/${clientProfileImage}`
    : "/assets/images/default-profile-account.jpg";

  const handleClientLogout = () => {
    googleLogout();
    dispatch(logout());
    navigate("/");
  };

  const donateButton = (
    <Link
      to="/ways-to-give#donate"
      className="btn btn-danger rounded-pill px-3 px-lg-4 fw-semibold d-inline-flex align-items-center gap-1"
      style={{
        background: "linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)",
        color: "#1f2937",
      }}
    >
      Donate
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth="2.5"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
        />
      </svg>
    </Link>
  );

  return (
    <>
      {/* <div className="navbar-main">
        <nav className="navbar">
          <div className="nav-left">
            {tabs.map((tab) => (
            <Link
              key={tab.name}
              to={tab.path}
              className={`nav-btn ${location.pathname === tab.path ? 'active' : ''}`}
            >
              {tab.name}
            </Link>
          ))}
          </div>
          <div className="nav-right">
            <span>
              <img
                src={whatsAppImg}
                alt="Whatsapp Logo"
                className="wp-logo-img"
              />
            </span>
            <div>
              <span className="wp-contact-details">WhatsApp No.</span>
              <br />
              <span className="wp-contact-details">+91 98798 12020</span>
            </div>
          </div>
        </nav>
      </div> */}
      <nav className="navbar navbar-expand-lg py-2 py-lg-0">
        <div className="container position-relative px-3">
          {/* <Link to="/"> */}
          <a className="navbar-brand logo me-0 py-0 mb-0" href="/"><img src="/assets/images/logo.png" style={{ maxWidth: "50%" }} className="img-fluid" /></a>
          {/* </Link> */}
          <div className="d-flex align-items-center">
            {/* {!isClientLoggedIn && ( */}
              <div className="d-lg-none me-2">{donateButton}</div>
            {/* )} */}
            <div className="d-lg-none"><a href="#" className="text-decoration-none"><img src="/assets/images/header-gmail.svg" alt="..." className="" /></a></div>
            <div className="mx-3 d-lg-none"><a href="#" className="text-decoration-none"><img src="/assets/images/header-call.svg" alt="..." className="" /></a></div>
            {/* <button className="navbar-toggler text-danger p-0" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
              <img src="/assets/images/menu-arrow.png" className="img-fluid" style={{ position: "relative", top: "-2px" }} />
            </button> */}
            <button
              className="navbar-toggler text-danger p-0"
              type="button"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-controls="navbarCollapse"
              aria-expanded={isMenuOpen}
              aria-label="Toggle navigation"
            >
              <img
                src="/assets/images/menu-arrow.png"
                className="img-fluid"
                style={{ position: "relative", top: "-2px" }}
              />
            </button>
          </div>
          <div className={`collapse navbar-collapse nav-menu ${isMenuOpen ? "show" : ""}`} id="navbarCollapse">
            <ul className="navbar-nav menu ms-auto m-0 text-capitalize font-weight-medium font-size-14 align-items-lg-center me-lg-4">

              <li className="nav-item">
                <Link className="nav-link text-white" to="/">Home</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link text-white" to="/client-services">Find a Provider</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link text-white" to="#">Financial Support</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link text-white" to="#">Education Hub</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link text-white" to="/community">Forum</Link>
              </li>

              <li className="nav-item dropdown">
                <button
                  className="nav-link dropdown-toggle text-white border-0 bg-transparent font-weight-medium"
                  type="button"
                  id="supportJgfDropdown"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Support JGF
                </button>
                <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="supportJgfDropdown">
                  {fundraisingLinks.map((item) => (
                    <li key={item.path}>
                      <Link className="dropdown-item py-2 px-3" to={item.path}>
                        {item.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </li>

              {isClientLoggedIn && (
                <>
                  {clientIsVerified !== 'Y' && (
                    <li className="nav-item">
                      <Link className="nav-link text-white" to="/panel/verify">ID Verification</Link>
                    </li>
                  )}
                </>
              )}
            </ul>

            {isClientLoggedIn ? (
              <div className="d-flex log-in">
                <div className="d-flex align-items-center ps-3 ps-lg-0 py-3 py-lg-0">
                  <div className="d-flex align-items-center">

                    <div className="font-size-14 font-weight-normal line-hight-3 text-whightlight me-2">
                      <h2 className="font-weight-semibold text-white font-size-18 mb-0 line-hight-2">
                        {clientName || "Guest"}
                      </h2>
                    </div>

                    <div className="me-3">
                      <img src={clientImageUrl} alt="Profile" className="img-fluid"
                        style={{
                          height: "35px",
                          width: "35px",
                          borderRadius: "8px"
                        }}
                      />
                    </div>

                    <div className="position-relative">
                      <Link to="/client/chat/provider">
                        <i className="fa fa-bell fa-lg text-white"></i>

                        {unreadCount > 0 && (
                          <span
                            className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                            style={{ fontSize: "0.7rem", minWidth: "18px" }}
                          >
                            {unreadCount}
                          </span>
                        )}
                      </Link>
                    </div>

                    <div className="d-none d-lg-block me-2 ms-lg-2 my-2 my-lg-0">
                      {donateButton}
                    </div>

                    <div className="dropdown m-2">
                      <button
                        className="btn btn-sm btn-outline-light dropdown-toggle"
                        type="button"
                        id="providerDropdown"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        ☰
                      </button>

                      <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="providerDropdown">
                        <li>
                          <Link className="dropdown-item" to="/panel/info"> My Account </Link>
                        </li>
                        <li className="mt-2">
                          <button className="dropdown-item" onClick={handleClientLogout}>
                            Logout
                          </button>
                        </li>
                      </ul>
                    </div>

                  </div>
                </div>
              </div>
            ) : (
              <div className="d-flex log-in">
                <div className="d-flex align-items-center ps-3 ps-lg-0 py-3 py-lg-0">
                  {/* ✅ Desktop-only Donate button — still inside menu, hidden on mobile */}
                  <div className="d-none d-lg-block me-2 ms-lg-2 my-2 my-lg-0">
                    {donateButton}
                  </div>

                  <Link to="/signup">
                    <button
                      className="btn btn-light-header font-weight-medium rounded me-2"
                      style={{ padding: "6px" }}
                    >
                      <span className="d-block">Get Started</span>
                    </button>
                  </Link>
                  <div className="dropdown">
                    <button
                      className="btn btn-light-header font-weight-medium rounded"
                      style={{ padding: "6px" }}
                      data-bs-toggle="dropdown"
                      id="loginDropdown"
                    >
                      <span className="d-block">
                        Log In <i className="ms-1 fa fa-caret-down" aria-hidden="true"></i>
                      </span>
                    </button>
                    <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="loginDropdown">
                      <li><Link className="dropdown-item py-2 px-3" to="/signin">Parent</Link></li>
                      <li><Link className="dropdown-item py-2 px-3" to="/provider/signin">Provider</Link></li>
                    </ul>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </nav>
    </>
  );
};

export default ClientNavbar;
